import React from 'react';

export const ReactTestComponent = () => {
  return (
    <div
      id="react-test-component"
      style={{
        border: '2px solid #4CAF50',
        padding: '20px',
        margin: '20px',
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
      }}
    >
      <h1 style={{ color: '#4CAF50' }}>Nicholas Hendrickson</h1>
      <p style={{ fontSize: '1.2em' }}>
        This is a personal domain. It's currently under construction and is unrelated to any of my work-related endeavours.
      </p>
    </div>
  );
};
